import algoliasearch from 'algoliasearch'
import { getEnvVar } from '@mc/client-env'

export default algoliasearch(
  getEnvVar('ALGOLIA_APP_ID'),
  getEnvVar('ALGOLIA_SEARCH_BROWSE_KEY'),
)
